import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Manualtemplate extends Component {
 
  render() {
    const course =[

      {
        title: "Introduction to Software Testing",
        content: [
        "Overview of software testing",
        "Objectives and benefits of software testing",
        "Types of software testing",
        "Software development life cycle"
        ]
        },
        {
        title: "Testing Techniques",
        content: [
        "Black box testing",
        "White box testing",
        "Gray box testing",
        "Equivalence partitioning",
        "Boundary value analysis",
        "Decision table testing",
        "State transition testing",
        "Use case testing",
        "Exploratory testing"
        ]
        },
        {
        title: "Test Planning",
        content: [
        "Test planning process",
        "Test plan document",
        "Test strategy",
        "Test estimation",
        "Risk analysis in testing"
        ]
        },
        {
        title: "Test Design",
        content: [
        "Test design techniques",
        "Test case design",
        "Test data preparation",
        "Test environment setup"
        ]
        },
        {
        title: "Test Execution",
        content: [
        "Test execution process",
        "Defect management",
        "Test closure",
        "Test summary report"
        ]
        },
        {
        title: "Functional Testing",
        content: [
        "Functional testing overview",
        "Unit testing",
        "Integration testing",
        "System testing",
        "Acceptance testing"
        ]
        },
        {
        title: "Non-Functional Testing",
        content: [
        "Non-functional testing overview",
        "Performance testing",
        "Security testing",
        "Usability testing",
        "Compatibility testing"
        ]
        },
        {
        title: "Regression Testing",
        content: [
        "Regression testing overview",
        "Regression test suite design",
        "Regression test selection",
        "Regression test execution"
        ]
        },
        {
        title: "Test Automation",
        content: [
        "Introduction to test automation",
        "Test automation framework",
        "Automated testing tools",
        "Test automation design",
        "Test automation implementation"
        ]
        },
        {
        title: "API Testing",
        content: [
        "API testing overview",
        "API testing tools",
        "API testing design",
        "API testing implementation",
        "API testing challenges"
        ]
        },
        {
        title: "Mobile Testing",
        content: [
        "Mobile testing overview",
        "Mobile testing tools",
        "Mobile testing design",
        "Mobile testing implementation",
        "Mobile testing challenges"
        ]
        },
        {
        title: "Best Practices in Software Testing",
        content: [
        "Software testing best practices",
        "Testing documentation",
        "Testing metrics",
        "Continuous testing",
        "Challenges and trends in software testing"
        ]
        }
    ]

    const faqData = [
      {
        question: 'What is manual testing?',
        answer:
          'Manual testing is a process where testers manually execute test cases without using any automation tools. It involves verifying software applications or systems to ensure they meet specified requirements and function correctly.',
      },
      {
        question: 'why is manual testing training important ?',
        answer:
          'Manual testing training equips individuals with the necessary skills and knowledge to effectively identify defects and verify software functionality manually. It provides a structured learning environment where participants can learn testing techniques, methodologies, and best practices.',
      },
      {
        question: 'How does manual testing compare to automated testing?',
        answer:
          'While both manual testing and automated testing have their advantages and disadvantages, automated testing is generally faster and more efficient for repetitive or time-consuming tests, while manual testing is better suited for exploratory testing, usability testing, and identifying visual defects.'
        
        },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'Career opportunities for manual testers include roles such as QA analyst, software tester, test engineer, and test lead. Experienced manual testers may also transition into roles such as test automation engineer or software development engineer in test (SDET).'
     },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Eligibility for training in manual testing is typically open to individuals from diverse educational and professional backgrounds. While there are no strict prerequisites for enrolling in manual testing courses, having a basic understanding of computer science concepts and familiarity with software applications can be beneficial. Candidates with degrees in computer science, information technology, engineering, or related fields may find it easier to grasp testing principles and methodologies. However, individuals without formal technical education can also pursue manual testing training, as long as they possess a keen interest in software testing and a willingness to learn. Good analytical skills, attention to detail, and the ability to communicate effectively are essential attributes for success in manual testing. Whether you're a recent graduate, a career changer, or an experienced professional looking to enhance your skills, manual testing training offers an accessible pathway to a rewarding career in quality assurance and software testing. "
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
 
     return(
      <>
{/*          
          <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Manual testing is the process of manually testing software for defects. It requires a tester to play the role of an end user where by they use most of the application&apos;s features to ensure correct behaviour."/>
            */}
            
           <NewMainsec rating='4.1' students={"276"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Manual testing is the process of manually testing software for defects. It requires a tester to play the role of an end user where by they use most of the application&apos;s features to ensure correct behaviour."/>

            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Manual Testing ${this.props.location1} is a crucial field with a high demand for professionals with manual testing skills. At Learnsoft.org, we provide top-notch manual testing training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of manual testing principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to manual testing or looking to expand your skillset, Learnsoft.org's manual testing ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your manual testing journey.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our manual testing course covers a wide range of topics, including test planning, test design, test execution, and test closure. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in manual testing. By the end of the course, you will be able to implement manual testing practices in your own projects."}/>
           </section>
 <Batchtime title={this.props.title} fees="20,999" offer="12,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>      
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou="TypeScript" coupath="type-script" cou1='Java' coupath1='java' cou2='ETL Testing' coupath2='etl-testing' cou3='Cucumber' coupath3='cucumber' cou4='Python' coupath4='python' 
          cou5='Dart Programming' coupath5='dart' cou6='JavaScript' coupath6='javascript' cou7='Pega' coupath7='pega' cou8='Go Lang' coupath8='go' cou9='R Programming' coupath9='rprogram'  cou10='ReactJS' coupath10='reactjs'/>
    
      </>
    );
  }
}
